import type { FC, PropsWithChildren } from 'react'

import { Translation } from '@/app/translations/Translation'

export const NoResultsWrapper: FC<PropsWithChildren<{ numOfResults: number }>> = ({
  children,
  numOfResults,
}) => {
  if (numOfResults === 0) {
    return (
      <div className="no-results">
        <Translation id="no data for this period" />
      </div>
    )
  }

  return <>{children}</>
}
